import { CloseOutlined } from '@ant-design/icons';
import { Button, Flex } from 'antd';
import { useTranslation } from 'translations/hooks';

import { SegmentHistory } from 'business/quality-control/pages/segment-history/hooks/data/types';
import { Quality_SegmentHistoryStatusEnum_Enum } from 'generated/graphql';
import { CapSidebar } from 'ui/sidebar';

import { DetailsHeader } from './components/details-header';
import { QuarantineDetails } from './components/quarantine-details';
import { RejectionDetails } from './components/rejection-details';

interface SegmentDetailsDrawerProps {
  segmentId: string | null;
  segments: SegmentHistory[];
  open: boolean;
  setSelectedSegment: (segment: SegmentHistory) => void;
  onClose: () => void;
  afterOpenChange: (open: boolean) => void;
  refetchData: () => void;
  mobile: boolean;
  isUserManager: boolean;
}

export const SegmentDetailsDrawer = ({
  segmentId,
  segments,
  open,
  setSelectedSegment,
  onClose,
  afterOpenChange,
  refetchData,
  mobile,
  isUserManager,
}: SegmentDetailsDrawerProps) => {
  const { t } = useTranslation();

  const segment = segments.find((s) => s.id === segmentId);
  const segmentIndex = segments.findIndex((s) => s.id === segmentId);
  const nextSegment = segments[segmentIndex + 1];
  const previousSegment = segments[segmentIndex - 1];

  return (
    <CapSidebar
      title={t('qualityControl.segmentHistory.drawer.title')}
      onClose={onClose}
      afterOpenChange={afterOpenChange}
      open={open}
      closable={false}
      forceRender
      placement={mobile ? 'bottom' : 'right'}
      width={400}
      height={700}
      extra={<Button type="text" icon={<CloseOutlined />} onClick={onClose} />}
    >
      <Flex gap={24} vertical>
        {segment ? (
          <>
            <DetailsHeader
              segment={segment}
              nextSegment={nextSegment}
              previousSegment={previousSegment}
              setSelectedSegment={setSelectedSegment}
            />

            {segment?.history
              ?.filter(
                (history) =>
                  history.status ===
                  Quality_SegmentHistoryStatusEnum_Enum.Quarantine,
              )
              .map((history, index, filtered) => (
                <QuarantineDetails
                  key={history.id}
                  historyEntry={history}
                  entryIndex={index}
                  entryNumber={filtered.length}
                  refetchData={refetchData}
                  mobile={mobile}
                  isUserManager={isUserManager}
                />
              ))}

            {segment?.history
              ?.filter(
                (history) =>
                  history.status ===
                    Quality_SegmentHistoryStatusEnum_Enum.Rejected &&
                  history.segmentRefusal != null,
              )
              .map((history) => (
                <RejectionDetails key={history.id} historyEntry={history} />
              ))}
          </>
        ) : null}
      </Flex>
    </CapSidebar>
  );
};
